import { donationForm as TEXT } from 'locales/en/cart';
import yup from 'utils/yupHelpers';
export const FIELD_NAMES = {
  amount: 'amount',
  custom_amount: 'custom_amount',
  radio: 'radio',
  user_pays_fees: 'user_pays_fees',
  message: 'message',
  is_anonymous: 'is_anonymous',
};

const schema = yup.object().shape({
  [FIELD_NAMES.radio]: yup.string(),
  [FIELD_NAMES.is_anonymous]: yup.bool(),
  [FIELD_NAMES.amount]: yup.string().when(FIELD_NAMES.radio, {
    is: (value) => value && value === 'false',
    then: yup.string().required(TEXT.errors.amount.required),
  }),
  [FIELD_NAMES.custom_amount]: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .when(FIELD_NAMES.radio, {
      is: (val) => val === 'true',
      then: yup
        .number()
        .nullable()
        .transform((value, originalValue) =>
          originalValue === '' ? null : value
        )
        .min(3, TEXT.errors.amount.min)
        .required(TEXT.errors.amount.required),
    }),
});

export default schema;
